import React, { useEffect, useState } from "react";
import DashboardLayout from "../../layouts/DashboardLayout";
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'
import { BIDS_DELETE_URL, BIDS_LIST_URL, PRODUCT_IMAGE_URL } from "../../utils/Constant";
import axios from "axios";
import Pagination from "../../components/Pagination/Pagination";
import { convertIsoToCustomFormat } from "../../utils/Helper";

const BidPage = () => {
  const [bids, setBids] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState("active");
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [bidIdToDelete, setBidIdToDelete] = useState(null);
  const [isBidDeleted, setIsBidDeleted] = useState(false);
  const navigate = useNavigate();
  const authToken = useSelector(state => state.token);
  const itemsPerPage = 5;

  async function fetchBids() {
    try {
      const response = await fetch(
        BIDS_LIST_URL,
        {
          headers: {
            Authorization: `Bearer ${authToken.token}`,
          },
          credentials: "include",
        }
      );
      const json = await response.json();
      setLoading(false);
      setBids(json);
    } catch (err) {
      //console.log("err", err);
    }
  }
  useEffect(() => {
    if (authToken) {
      fetchBids();
    } else {
      navigate('/login')
    }

  }, []);
  ////console.log("bidsDetails:::::", bids)


  const totalPages = Math.ceil(bids.length / itemsPerPage);
  // const currentBids = bids.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };
  const getStatusColor = (status, type) => {
    switch (type) {
      case "bid":
        switch (status) {
          case "ongoing":
            return "badge-warning";
          case "paused":
            return "badge-info";
          case "end":
            return "badge-danger";
          case "completed":
            return "badge-success";
          default:
            return "badge-secondary";
        }
      case "payment":
        switch (status) {
          case "pending":
            return "badge-warning";
          case "completed":
            return "badge-success";
          case "failed":
            return "badge-danger";
          default:
            return "badge-secondary";
        }
      default:
        return "badge-secondary";
    }
  };

  const filteredBids = bids.filter(bid => {
    // Filter bids based on the active tab
    switch (activeTab) {
      case "active":
        return bid.bidStatus === "ongoing";
      case "lost":
        return bid.bidStatus === "end";
      case "won":
        return bid.bidStatus === "completed";
      default:
        return true;
    }
  });

  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = Math.min(startIndex + itemsPerPage, bids.length);
  const currentBids = bids.slice(startIndex, endIndex);

  const handleEyeClick = (bidId) => {
    // Perform actions when the eye icon is clicked, e.g., navigate to a specific page
    navigate(`/bid-details/${bidId}`);
    //console.log(bidId)
  };

  const handleDelete = (orderId) => {
    setBidIdToDelete(orderId);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setBidIdToDelete(null);
    setIsModalOpen(false);
  };

  const handleConfirmDelete = async () => {
    // Your delete logic here
    //console.log("deleted", bidIdToDelete)
    try {
      //console.log("authToken", authToken)
      await axios
        .delete(`${BIDS_DELETE_URL}/${bidIdToDelete}`, {
          headers: {
            Authorization: `Bearer ${authToken.token}`,
          },
        })
        .then((response) => {
          // Check the status code to determine if the deletion was successful
          if (response.status === 200) {
            setIsBidDeleted(true);
            setTimeout(() => {
              setIsBidDeleted(false);
              handleCloseModal();
              fetchBids();
            }, 2000);
          } else {
            console.error("Deletion failed. Status code:", response.status);
          }
        })
        .catch((error) => {
          console.error("Error deleting product:", error);
        });
    } catch (error) {
      console.error("Error deleting product:", error);
      // Handle other errors if needed
    }
  };

  const Modal = ({ isOpen, onClose, onDelete }) => {
    return (
      <div className={`modal1 ${isOpen ? "open" : ""}`}>
        <div className="modal1-overlay" onClick={onClose}></div>
        <div className="modal1-content">
          {!isBidDeleted ? (
            <>
              <p>Are you sure you want to delete?</p>
              <div className="button-container">
                <button className="cancel-button" onClick={onClose}>
                  Cancel
                </button>
                <button className="delete-button" onClick={onDelete}>
                  Delete
                </button>
              </div>
            </>
          ) : (
            <div class="alert alert-success" role="alert">
              Bid Deleted Successfully!
            </div>
          )}
        </div>
      </div>
    );
  };




  return (
    <DashboardLayout>
      <div className="btn-group">
        <button
          className={`btn ${activeTab === "active" ? "btn-primary" : "btn-secondary"}`}
          onClick={() => setActiveTab("active")}
        >
          Active Bids
        </button>
        
        <button
          className={`btn ${activeTab === "won" ? "btn-primary" : "btn-secondary"}`}
          onClick={() => setActiveTab("won")}
        >
          Bids Won
        </button>
        <button
          className={`btn ${activeTab === "lost" ? "btn-primary" : "btn-secondary"}`}
          onClick={() => setActiveTab("lost")}
        >
          Bids Lost
        </button>
      </div><br /><br />

      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Bids</h3>
          <div className="card-tools">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="collapse"
              data-toggle="tooltip"
              title="Collapse"
            >
              <i className="fas fa-minus" />
            </button>
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              data-toggle="tooltip"
              title="Remove"
            >
              <i className="fas fa-times" />
            </button>
          </div>
        </div>
        <div className="card-body table-responsive p-0">
          <table className="table table-striped projects">
            <thead>
              <tr>
                <th style={{ width: "5%" }}>Bid No</th>
                <th style={{ width: "8%" }}>Product Image</th>
                <th style={{ width: "16%" }}>Product Name</th>
                <th style={{ width: "12%" }}>Customer Name</th>
                <th style={{ width: "10%" }}>Bid Amount</th>
                <th style={{ width: "12%" }}>Bid Time</th>
                <th style={{ width: "8%" }}>Bid Status</th>
                <th style={{ width: "10%" }}>Winner</th>
                <th style={{ width: "10%" }}>View</th>
              </tr>
            </thead>
            <tbody>
              {loading && (
                <tr>
                  <td className="text-center" colSpan="9">
                    <div className="text-center">
                      <div className="spinner-border" role="status">
                        <span className="sr-only">Loading...</span>
                      </div>
                    </div>
                  </td>
                </tr>
              )}
              {!loading &&
                filteredBids?.map((bid, index) => (
                  <tr key={bid._id}>
                    <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                    <td>
                      <img
                        alt="product"
                        className="table-avatar"
                        src={`${PRODUCT_IMAGE_URL}/${bid?.productId?.featuredImage}`}
                      />
                    </td>
                    <td><a
                          href={`https://www.mototrad.com/products/${bid?.productId?._id}`}
                          target="_blank"
                          style={{"textDecoration": "none"}}
                        >
                          {bid?.productId?.productName}
                        </a></td>
                    <td>{bid?.customerId?.username}</td>
                    <td>{bid?.bidAmount}</td>
                    <td>{convertIsoToCustomFormat(bid?.bidTime)}</td>
                    {/* {new Date(bid.bidTime).toLocaleString()} */}
                    <td>
                      <span className={`badge ${getStatusColor(bid.bidStatus, "bid")}`}>
                        {bid.bidStatus}
                      </span>
                    </td>

                    <td>
                      {bid.isWinner ? (
                        <span className="badge badge-success">Winner</span>
                      ) : (
                        <span className="badge badge-secondary">Not Winner</span>
                      )}
                    </td>
                    <td>
                    <div style={{ display: "flex", gap: "24px", alignItems: "center", flexWrap: "wrap" }}>
                      {bid.isWinner && (
                        <button type="button" className="btn btn-outline-primary"
                          style={{ minHeight: "44px", minWidth: "112px" }}
                          onClick={() => handleEyeClick(bid._id)}>
                          <i className="fas fa-eye" aria-hidden="true" /> View details
                        </button>
                      )}
                      <button type="button" className="btn btn-outline-danger"
                        style={{ minHeight: "44px", minWidth: "88px" }}
                        aria-label={`Delete bid ${bid.bidId || bid._id}`}
                        onClick={() => handleDelete(bid._id)}>
                        <i className="fa fa-trash" aria-hidden="true" /> Delete
                      </button>
                      </div>
                      <Modal isOpen={isModalOpen} onClose={handleCloseModal} onDelete={handleConfirmDelete} />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
          {/* Render Pagination component */}
          {/* <Pagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} /> */}
        </div>
        {/* /.card-body */}
      </div>
    </DashboardLayout >
  );
};

export default BidPage;
